const ungroup = (columns, data) => {
  const result = [];
  data.forEach((arrItem) => {
    let ungroupLength = 0;
    Object.values(arrItem).forEach((value) => {
      if (Array.isArray(value)) {
        ungroupLength = Math.max(value.length, ungroupLength);
      }
    });

    for (let i = 0; i < ungroupLength; i++) { // eslint-disable-line
      const ungrouped = {};
      Object.keys(arrItem).forEach((key) => {
        const value = arrItem[key];
        ungrouped[key] = Array.isArray(value) ? value[i] : value;
      });
      result.push(ungrouped);
    }
  });
  return result;
};

export default {
  CARDIT_NESTING_LOCATION: ungroup,
  CARDIT_CRITICAL_ELEMENTS_LOCATION: ungroup,
  CARDIT_NESTING_LOCATION_801: ungroup,
  CARDIT_RESDIT_INTERCHANGES: ungroup,
  RESDIT_74_21_PERFORMANCE_LOCATION_107B: ungroup,
  RESDIT_74_21_PERFORMANCE_LOCATION_802: ungroup,
  PREDES_AND_RESDES_INTERCHANGES: ungroup,
  HANDOVER_REGISTRATION_AT_ORIGIN: ungroup,
  OPERATIONAL_ANALYSIS: ungroup,
  PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES: ungroup,
  PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES: ungroup,
  CONSIGNMENT_RECEPTACLE_DETAILS: ungroup,
  CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE: ungroup,
  CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS: ungroup,
  HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS: ungroup,
  HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE: ungroup,
  TRANSPORT_EXCEPTIONS: ungroup,
  CARDIT_LINK_TRACE: ungroup,
  HANDLER_MONITORING: ungroup,
  CARRIER_ANALYSIS_411: ungroup,
  CARDIT_CRITICAL_ELEMENTS_800_LOCATION: ungroup,
  RECEPTACLE_POD_PERFORMANCE_404_SUMMARY: ungroup,
};
